import styled from 'styled-components';

import type { DividerItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/dividerItemAttributes';

interface DividerUIProps {
  attributes?: DividerItemAttributes;
  defaultBgColor?: string;
}

const DividerUI = ({ attributes, defaultBgColor }: DividerUIProps) => (
  <Divider
    $attributes={attributes}
    data-testid="builder-component-divider"
    $defaultBgColor={defaultBgColor}
  />
);

export default DividerUI;

interface DividerStyle {
  $attributes?: DividerItemAttributes;
  $defaultBgColor?: string;
}

const Divider = styled.div<DividerStyle>`
  border-top-color: ${({ $attributes, $defaultBgColor }) =>
    $attributes?.dividerColor || $defaultBgColor};
  border-top-width: ${({ $attributes }) => `${$attributes?.dividerHeight}px`};
  border-top-style: ${({ $attributes }) => $attributes?.dividerStyle};
  width: ${({ $attributes }) => `${$attributes?.dividerWidth}%`};
`;
